import type { SvgComponent } from '@/types/SvgComponent';

export const ListIcon: SvgComponent = ({ title, ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {title ? <title>{title}</title> : null}
      <path d="M3.75 12H20.25" stroke="currentColor" strokeWidth="1.13" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M3.75 6H20.25" stroke="currentColor" strokeWidth="1.13" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M3.75 18H20.25" stroke="currentColor" strokeWidth="1.13" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};
